"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateStudentsMapper = exports.updateGroupsMapper = exports.sortClassesAndGroupsStudents = exports.sortByStudentFullName = exports.sortByGroupName = exports.mapStudents = exports.mapClassesAndGroups = exports.getStudentFullName = exports.getAudienceData = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getStudentFullName = function getStudentFullName(student) {
  return student ? student.lastName + ' ' + student.firstName : '';
};
exports.getStudentFullName = getStudentFullName;
var getAudienceData = function getAudienceData(groups, audienceID) {
  var _audienceSingleStuden;
  var audienceGroups = groups.filter(function (group) {
    return group.groupType !== 'audience';
  }).map(function (group) {
    return group.id;
  });
  var audienceSingleStudents = groups.filter(function (group) {
    return group.groupType === 'audience';
  });
  var audienceStudents = (_audienceSingleStuden = audienceSingleStudents[0]) === null || _audienceSingleStuden === void 0 ? void 0 : _audienceSingleStuden.students.map(function (student) {
    return {
      ContextGroupID: student.contextGroupId,
      UserID: student.id
    };
  });
  var audienceData = {
    AudienceId: audienceID,
    Groups: audienceGroups,
    SingleUsers: audienceStudents
  };
  return audienceData;
};
exports.getAudienceData = getAudienceData;
var mapClassesAndGroups = function mapClassesAndGroups(group, userId, mappers) {
  var mapper;
  if (group.groupType !== 'audience') {
    mapper = group.groupType === 'class' ? mappers.classes : mappers.groups;
    if (!mapper[group.id]) {
      mapper[group.id] = {
        group: _objectSpread({}, group),
        teacherIds: [],
        studentIds: []
      };
    }
    mapper[group.id].teacherIds.push(userId);
  }
};
exports.mapClassesAndGroups = mapClassesAndGroups;
var mapStudents = function mapStudents(group, mappers) {
  var _group$students;
  (_group$students = group.students) === null || _group$students === void 0 ? void 0 : _group$students.forEach(function (student) {
    if (!mappers.students[student.id]) {
      mappers.students[student.id] = {
        student: _objectSpread({}, student),
        groupIds: [],
        classIds: []
      };
    }
    if (group.groupType === 'audience') {
      mappers.singleStudents[student.id] = {
        student: _objectSpread({}, student),
        groupIds: [],
        classIds: [],
        audienceId: group.id
      };
      mappers.students[student.id].audienceId = group.id;
    } else {
      var mapper = group.groupType === 'class' ? mappers.classes : mappers.groups;
      mapper[group.id].studentIds.push(student.id);
      if (group.groupType === 'class') {
        mappers.students[student.id].classIds.push(group.id);
      } else {
        mappers.students[student.id].groupIds.push(group.id);
      }
    }
  });
};
exports.mapStudents = mapStudents;
var sortClassesAndGroupsStudents = function sortClassesAndGroupsStudents(group, mappers) {
  var mapper = group.groupType === 'class' ? mappers.classes : mappers.groups;
  if (group.groupType !== 'audience') {
    mapper[group.id].studentIds.sort(function (a, b) {
      return getStudentFullName(mappers.students[a].student) < getStudentFullName(mappers.students[b].student) ? -1 : getStudentFullName(mappers.students[a].student) > getStudentFullName(mappers.students[b].student) ? 1 : 0;
    });
  }
};
exports.sortClassesAndGroupsStudents = sortClassesAndGroupsStudents;
var sortByGroupName = function sortByGroupName(mapper) {
  return Object.keys(mapper).sort(function (a, b) {
    return mapper[a].group.name < mapper[b].group.name ? -1 : mapper[a].group.name > mapper[b].group.name ? 1 : 0;
  });
};
exports.sortByGroupName = sortByGroupName;
var sortByStudentFullName = function sortByStudentFullName(mapper) {
  return Object.keys(mapper).sort(function (a, b) {
    return getStudentFullName(mapper[a].student) < getStudentFullName(mapper[b].student) ? -1 : getStudentFullName(mapper[a].student) > getStudentFullName(mapper[b].student) ? 1 : 0;
  });
};
exports.sortByStudentFullName = sortByStudentFullName;
var updateGroupsMapper = function updateGroupsMapper(group, groupsMapper, userIds, studentsSelectorTempData) {
  var newGroupsMapper = _objectSpread({}, groupsMapper);
  if (!newGroupsMapper[group.id]) {
    newGroupsMapper[group.id] = {
      group: _objectSpread({}, group),
      teacherIds: [],
      studentIds: []
    };
  } else {
    newGroupsMapper[group.id] = _objectSpread(_objectSpread({}, newGroupsMapper[group.id]), group);
  }
  newGroupsMapper[group.id].teacherIds = _toConsumableArray(userIds);
  newGroupsMapper[group.id].studentIds = _toConsumableArray(studentsSelectorTempData.selectedStudentsIds);
  userIds.forEach(function (id) {
    if (newGroupsMapper[group.id].teacherIds.indexOf(id) < 0) {
      newGroupsMapper[group.id].teacherIds.push(id);
    }
  });
  return newGroupsMapper;
};
exports.updateGroupsMapper = updateGroupsMapper;
var updateStudentsMapper = function updateStudentsMapper(group, studentsMapper, newGroupsMapper, studentsSelectorTempData) {
  var newStudentsMapper = _objectSpread({}, studentsMapper);
  studentsSelectorTempData.selectedStudentsIds.forEach(function (id) {
    if (newGroupsMapper[group.id].studentIds.indexOf(id) < 0) {
      newGroupsMapper[group.id].studentIds.push(id);
    }
    if (newStudentsMapper[id]) {
      if (!newStudentsMapper[id].groupIds) {
        newStudentsMapper[id].groupIds = [];
      }
      if (newStudentsMapper[id].groupIds.indexOf(group.id) < 0) {
        newStudentsMapper[id].groupIds.push(group.id);
      }
    }
  });
  return newStudentsMapper;
};
exports.updateStudentsMapper = updateStudentsMapper;